

























































































































































































































































































import Vue from "vue";
import deleteMenuItemConfirmation from "./deleteMenuItemConfirmation.vue";
import {
  ADD_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  ADD_DISH,
  DELETE_DISH,
  UPDATE_DISH_NAME,
  UPDATE_CATEGORY_SORT_INDEX,
  UPDATE_DISH_SORT_INDEX
} from "@/queries/user/mutation.graphql";
import { GET_MENU } from "@/queries/user/query.graphql";

export default Vue.extend({
  data: () => ({
    openDeleteConfirmation: false,
    selectedItem: null,
    name: "",
    newDishName: "",
    delMode: ""
  }),
  computed: {
    categories: {
      get() {
        return this.$store.getters["userModule/categories"];
      },
      set(val) {
        console.log(val);
      }
    },
    menuId() {
      return this.$store.getters["userModule/menuId"];
    },
    categoryAccordion() {
      return this.$store.getters["userModule/categoriesAccordion"];
    }
  },
  methods: {
    onDelete() {
      if (this.delMode === "category") {
        this.deleteCategory();
      } else {
        this.deleteDish();
      }
    },
    addNewCategory(name, close) {
      const trimed = name.trim();
      if (trimed.length === 0) {
        this.$toastr.e("You should insert one character at list!");
        close();
        return;
      }
      this.$apollo
        .mutate({
          mutation: ADD_CATEGORY,
          variables: {
            name,
            menuId: this.menuId,
            sortIndex: this.$store.getters["userModule/categoriesLength"]
          },
          update: (cache, { data: { insert_Category } }) => {
            if (insert_Category) {
              const data: any = cache.readQuery({
                query: GET_MENU
              });

              data.Menu[0].Categories.push(insert_Category.returning[0]);
              cache.writeQuery({
                query: GET_MENU,
                data
              });
            }
          }
        })
        .then(data => {
          this.name = "";
          this.$toastr.s("Category added successfuly");
          this.$store.commit("userModule/toggleCategoryMenu", {
            elms: data.data.insert_Category.returning[0].id
          });
          close();
        })
        .catch(error => {
          this.$toastr.e("Category added before");
        });
    },
    deleteCategory() {
      const id = this.selectedItem.id;
      this.$apollo
        .mutate({
          mutation: DELETE_CATEGORY,
          variables: {
            menuId: this.menuId,
            id
          },
          update: (cache, { data: { delete_Category } }) => {
            if (delete_Category) {
              const data: any = cache.readQuery({
                query: GET_MENU
              });
              data.Menu[0].Categories = data.Menu[0].Categories.filter(
                el => el.id !== id
              );
              cache.writeQuery({
                query: GET_MENU,
                data
              });
            }
          }
        })
        .then(data => {
          if (this.$route.params.categoryId === id) {
            this.$router.replace({ name: "menu" });
          }
          this.openDeleteConfirmation = false;
          this.$toastr.s("Category Deleted successfuly");
        })
        .catch(error => {
          this.openDeleteConfirmation = false;
          this.$toastr.e("error");
        });
    },
    UpdateCategoryName(name, id, close) {
      const trimed = name.trim();
      if (trimed.length === 0) {
        this.$toastr.e("You should insert one character at list!");
        return;
      }
      this.$apollo
        .mutate({
          mutation: UPDATE_CATEGORY,
          variables: {
            menuId: this.menuId,
            id,
            name
          },
          update: (cache, { data: { update_Category } }) => {
            if (update_Category) {
              const data: any = cache.readQuery({
                query: GET_MENU
              });
              const category = data.Menu[0].Categories.find(el => el.id === id);
              category.name = name;
              cache.writeQuery({
                query: GET_MENU,
                data
              });
              close();
              this.name = "";
            }
          }
        })
        .then(data => {
          this.$toastr.s("Category updated successfuly");
          close();
        })
        .catch(error => {
          this.$toastr.e("Category added before");
        });
    },
    updateCategorySortIndex() {
      const objects = this.categories.map((el: any, index) => {
        return {
          name: el.name,
          sortIndex: index,
          menuId: this.menuId
        };
      });
      console.log(objects);

      this.$apollo.mutate({
        mutation: UPDATE_CATEGORY_SORT_INDEX,
        variables: { objects },
        update: (cache, { data: { insert_Category } }) => {
          if (insert_Category.affected_rows) {
            const data: any = cache.readQuery({
              query: GET_MENU
            });
            data.Menu[0].Categories.forEach((element, index) => {
              element.sortIndex = index;
            });
            cache.writeQuery({
              query: GET_MENU,
              data
            });
          }
        }
      });
    },
    addNewDish(name, categoryId, categoryIndex, close) {
      name = name.trim();
      if (name.length === 0) {
        this.$toastr.e("You should insert one character at list!");
        close();
        return;
      }
      const sortIndex = this.categories[categoryIndex].Dishes.length;
      this.$store.commit("userModule/setDishModel");
      const dish = this.$store.getters["userModule/dish"];
      this.$apollo
        .mutate({
          mutation: ADD_DISH,
          variables: {
            ...dish,
            name,
            categoryId,
            sortIndex
          },
          update: (cache, { data: { insert_Dish } }) => {
            if (insert_Dish) {
              const data: any = cache.readQuery({
                query: GET_MENU
              });
              data.Menu[0].Categories.find(
                el => el.id === categoryId
              ).Dishes.push(insert_Dish.returning[0]);
              cache.writeQuery({
                query: GET_MENU,
                data
              });
            }
          }
        })
        .then(data => {
          this.$toastr.s("Dish added successfuly");
          this.newDishName = "";
          close();
          const id = data.data.insert_Dish.returning[0].id;
          this.$router.push({
            name: "menu-dish",
            params: { categoryId, itemId: id }
          });
        })
        .catch(error => {
          this.$toastr.e("Dish added before");
        });
    },
    updateDishName(name, id, categoryId, close) {
      const trimed = name.trim();
      if (trimed.length === 0) {
        this.$toastr.e("You should insert one character at list!");
        return;
      }
      this.$apollo
        .mutate({
          mutation: UPDATE_DISH_NAME,
          variables: {
            id,
            name: trimed
          },
          update: (cache, { data: { update_Dish } }) => {
            if (update_Dish.affected_rows) {
              const data: any = cache.readQuery({
                query: GET_MENU
              });
              const category = data.Menu[0].Categories.find(
                el => el.id === categoryId
              );
              const dish = category.Dishes.find(el => el.id === id);
              dish.name = trimed;
              cache.writeQuery({
                query: GET_MENU,
                data
              });
              close();
            }
          }
        })
        .then(data => {
          this.$toastr.s("Dish updated successfuly");
          close();
        })
        .catch(error => {
          this.$toastr.e("Dish added before");
        });
    },
    updateDishSortIndex(event, categoryId, index) {
      const objects = this.categories[index].Dishes.map((el: any, index) => {
        return {
          name: el.name,
          sortIndex: index,
          categoryId,
          price: el.price,
          inStock: el.inStock
        };
      });

      this.$apollo.mutate({
        mutation: UPDATE_DISH_SORT_INDEX,
        variables: { objects },
        update: (cache, { data: { insert_Dish } }) => {
          if (insert_Dish.affected_rows) {
            const data: any = cache.readQuery({
              query: GET_MENU
            });
            data.Menu[0].Categories[index].Dishes.forEach((element, index) => {
              element.sortIndex = index;
            });
            cache.writeQuery({
              query: GET_MENU,
              data
            });
          }
        }
      });
    },
    deleteDish() {
      const id = this.selectedItem.id;
      this.$apollo
        .mutate({
          mutation: DELETE_DISH,
          variables: {
            id
          },
          update: (cache, { data: { delete_Dish_by_pk } }) => {
            if (delete_Dish_by_pk) {
              const data: any = cache.readQuery({
                query: GET_MENU
              });
              const categoryIndex = data.Menu[0].Categories.findIndex(
                el => el.id === this.selectedItem.catId
              );

              data.Menu[0].Categories[
                categoryIndex
              ].Dishes = data.Menu[0].Categories[categoryIndex].Dishes.filter(
                el => el.id !== id
              );

              cache.writeQuery({
                query: GET_MENU,
                data
              });
            }
          }
        })
        .then(data => {
          console.log(this.$route.params.itemId);
          if (this.$route.params.itemId === id) {
            this.$router.replace({ name: "menu" });
          }
          this.openDeleteConfirmation = false;
          this.$toastr.s("Dish is deleted successfully", "Item Deleted");
        })
        .catch(error => {
          this.openDeleteConfirmation = false;
          this.$toastr.e("error");
        });
    }
  },
  destroyed() {
    this.$store.commit("userModule/toggleCategoryMenu", {
      elms: this.categories,
      condition: false
    });
  },
  components: {
    deleteMenuItemConfirmation
  }
});
